import { useCallback } from "react";
import { Product } from "@core/types";
import { useWishListDataState } from "../wishListStore/useWishListStore";
import useUpdateProductsWishlist from "./useUpdateProductsWishlist";
import { useConfig } from "../config";

export const useWishlistToggle = () => {
  const config = useConfig();
  const isRemoteWishlistEnabled = config?.isRemoteWishlistEnabled;

  const toggleWishStore = useWishListDataState((s) => s.toggleWish);
  const isWishProduct = useWishListDataState((s) => s.isWishProduct);

  const { mutate } = useUpdateProductsWishlist();

  const toggleWish = useCallback(
    (productId: Product["id"]) => {
      toggleWishStore(productId);

      if (isRemoteWishlistEnabled) {
        console.log("mutate ->");
        mutate({ productIds: useWishListDataState.getState().wishListProducts });
      }
    },
    [toggleWishStore, mutate, isRemoteWishlistEnabled],
  );

  return { toggleWish, isWishProduct };
};
